import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFullMoon: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="full-moon, dark-mode, nasa"><circle cx="12.5" cy="7.5" r="0.75" fill="currentColor" stroke="currentColor" strokeWidth="1.5"/><circle cx="8.1" cy="9.6" r="1.1" fill="currentColor"/><circle cx="10" cy="15" r="2" stroke="currentColor" strokeWidth="1.5"/><path d="M20.5 9.03076C18.5268 9.27681 17 10.96 17 12.9998C17 14.7686 18.1481 16.2693 19.7397 16.7972" stroke="currentColor" strokeWidth="1.5"/><circle cx="12" cy="12" r="9.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconFullMoon;
